/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { margin, padding } from 'polished';
import round from 'lodash/round';

import { posNegZero } from 'app/utils/functionalUtils';
import t from 'app/utils/translate';
import Trend from 'app/components/commons/Trend';
import LineMeter from './LineMeter';
import StatBox from './StatBox';

const trendDirection = posNegZero('up', 'down');

type Props = {
  averageScore?: number,
  highScore?: number,
  layout?: 'horizontal' | 'vertical',
  maxScore: number,
  mediumTermAverage?: number,
  mediumTermTrend?: number,
  shortTermAverage?: number,
  shortTermTrend?: number,
  isSmall?: boolean
};

const StatsList = styled.ul(
  {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    ...margin(0, 0, 20),
    ...padding(5, 0)
  },
  ({ layout }) => ({
    flexDirection: layout === 'horizontal' ? 'row' : 'column'
  })
);

const StatsItem = styled.li(
  {
    flexGrow: 0,
    flexShrink: 0,
    ...padding(5, 15)
  },
  ({ layout, theme }) =>
    layout === 'horizontal'
      ? {
          flexBasis: '50%',
          [theme.mediaQuery.tabletPortraitAndUp]: {
            flexBasis: '25%'
          }
        }
      : {
          flexBasis: 'auto'
        }
);

const Star = styled.div(({ theme }) => ({
  color: theme.color.blue
}));

class QuickStats extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    averageScore: undefined,
    highScore: undefined,
    layout: 'horizontal',
    mediumTermAverage: undefined,
    mediumTermTrend: undefined,
    shortTermAverage: undefined,
    shortTermTrend: undefined,
    isSmall: false
  };

  render() {
    const {
      averageScore,
      layout,
      highScore,
      maxScore,
      mediumTermAverage,
      mediumTermTrend,
      shortTermAverage,
      shortTermTrend,
      isSmall
    } = this.props;

    return (
      <StatsList layout={layout}>
        <StatsItem layout={layout}>
          <StatBox
            icon={<LineMeter percent={averageScore / maxScore} />}
            label={t('Season Average')}
            value={round(averageScore, 2)}
            isSmall={isSmall}
          />
        </StatsItem>
        <StatsItem layout={layout}>
          <StatBox
            icon={<Star className="ion-ios-star" />}
            label={t('Highest Score')}
            value={highScore}
            isSmall={isSmall}
          />
        </StatsItem>
        <StatsItem layout={layout}>
          <StatBox
            icon={<Trend direction={trendDirection(shortTermTrend)} />}
            label={t('3 Game Avg')}
            value={shortTermAverage}
            isSmall={isSmall}
          />
        </StatsItem>
        <StatsItem layout={layout}>
          <StatBox
            icon={<Trend direction={trendDirection(mediumTermTrend)} />}
            label={t('6 Game Avg')}
            value={mediumTermAverage}
            isSmall={isSmall}
          />
        </StatsItem>
      </StatsList>
    );
  }
}

export default QuickStats;
